<template>
<experience-form />
</template>

<script>
import ExperienceForm from '@/components/profile/experience-form'
export default {
  components: { ExperienceForm }
}
</script>



// WEBPACK FOOTER //
// src/components/profile/edit-experience.vue